export const dpimLoggerCostant = {
    FETCH_BILLING: 'DPIM FETCH BILLING TILE',
    CANCEL_AUTOMATIC_PAYMENT: 'DPIM CANCEL AUTOMATIC PAYMENTS SUBMISSION',
    EDIT_AUTOMATIC_PAYMENT: 'DPIM EDIT AUTOMATIC PAYMENTS SUBMISSION',
    SETUP_AUTOMATIC_PAYMENT: 'DPIM SETUP AUTOMATIC PAYMENTS SUBMISSION',
    SUSPEND_AUTOMATIC_PAYMENT: 'DPIM SUSPEND AUTOMATIC PAYMENTS SUBMISSION',
    INITIALIZE_MANAGE_PAYMENT: 'DPIM INITIALIZE MANAGE PAYMENT PREFERENCES',
    PAYMENT_PREFERENCES: 'DPIM PAYMENT PREFERENCES VIEW'
};